import { Component, OnInit, Input } from '@angular/core';
import { EsperienzeListConfig, Experience, WMAIApiService, AuthService } from '../../core';
import { Status } from '../../core/models/status.model';
import { Router, ActivatedRoute } from '@angular/router';
import { Angulartics2 } from 'angulartics2';
import { WgisService } from 'src/app/wgis/wgis.service';

@Component({
  selector: 'app-esperienza-profile-list',
  templateUrl: './esperienza-profile-list.component.html'
})
export class EsperienzaProfileListComponent implements OnInit {

  public isUserLoggedIn = false;
  private username: string;

  constructor(
    private wmaiservice: WMAIApiService,
    private authservice: AuthService,
    private router: Router,
    private activatedroute: ActivatedRoute,
    private angulartics2: Angulartics2,
    private wgisservice: WgisService
  ) { 
    this.angulartics2.eventTrack.next({ 
      action: 'onShare', 
      properties: {label : 'EsperienzaProfileShare' },
    });

    this.angulartics2.eventTrack.next({ 
      action: 'onMouseEnter', 
      properties: {label : 'EsperienzaProfileMouseEnter' },
    });
  }

  @Input() results: Experience[] = [];

  ngOnInit() {
    window.scrollTo(0, 0);
  }

  zoomOn(scheda: Experience){
    // console.log(scheda);
    this.wgisservice.showEsperienzaByObj(scheda);
  }
  
  // onMouseEnter(idscheda: number){
  //   this.wgisservice.showSchedaIntenseById(idscheda);
  // }
}
